import Dialog, { IDialogProps } from '@/ui/dialog';
import { Button } from '@/ui/buttons';
// import { useTranslation } from '@/i18n';
import Image from 'next/image';
import {
  AccountInactive,
  SecurityTwo,
  StockLine,
  Lightning,
} from '@/ui/svg';

export default function CreateWalletSuccess(props: IDialogProps) {
  return (
    <>
      <Dialog {...props}>
        <div className="px-4">
          <Image
            src="/wallet/create-success.svg"
            alt=""
            width={144}
            height={161}
            className="mx-auto my-8"
          />
          <div className="flex flex-col tracking-[-0.2px] mt-4 px-4 mx-auto gap-1 text-[3.7vw] leading-[1.5]">
            <div className="text-left text-lg font-bold px-4 pb-[14px]">
              Your keyless wallet is ready
            </div>
            <div className="px-4 gap-4 flex items-center">
              <SecurityTwo />
              <div>Enhanced security</div>
            </div>
            <div className="px-4 gap-4 flex items-center">
              <StockLine />
              <div>Automated transactions</div>
            </div>
            <div className="px-4 gap-4 flex items-center">
              <Lightning />
              <div>Simplified experience</div>
            </div>
            <div className="px-4 gap-4 flex items-center">
              <AccountInactive className="w-5 h-5" />
              <div>Recover with multi-factor Authentication</div>
            </div>
          </div>
          <p className="text-secondary mt-4 px-8 text-[3.7vw]">
            The rewards will be received within 48 hours
          </p>
          <div className="px-4 mt-6">
            <Button
              onClick={() => {
                props.toggle(false);
              }}
              size="sm"
              type="primary"
            >
              Get started
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
}
